import React, { useState } from 'react';
import '../../css/book-call.css';

const BookCall = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <section className="book-call-section">
        <h1>Discover Automations for your Business</h1>
        <p>
          We tailor automated workflows for businesses like yours to streamline operations. Whether you have
          specific challenges or ambitious goals, we're here to discuss your challenges and mitigate those with AI.
        </p>
        <h2>What to Expect</h2>

        <h3>Step 1: Watch video</h3>
        <iframe
          width="100%"
          height="500"
          src="https://www.youtube.com/embed/your-video-id"
          title="UnsupervisedBias Video"
          frameBorder="0"
          allowFullScreen
        ></iframe>
        <h3>Step 2: Book call</h3>
        <p>Click the button below to schedule your free discovery call.</p>

        {/* Modal trigger button */}
        <button
          className="book-call-button"
          onClick={openModal}
          style={{
            padding: '16px 32px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#fff',
            background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(216, 134, 255, 0.4)',
            transition: 'all 0.3s ease',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginTop: '20px'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(216, 134, 255, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(216, 134, 255, 0.4)';
          }}
        >
          Schedule Discovery Call
        </button>
      </section>

      {/* Custom Modal Overlay */}
      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px',
            backdropFilter: 'blur(2px)'
          }}
          onClick={closeModal}
        >
          <div
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '1000px',
              height: '90vh',
              maxHeight: '800px',
              backgroundColor: '#fff',
              borderRadius: '16px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                width: '40px',
                height: '40px',
                border: 'none',
                borderRadius: '50%',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                color: '#333',
                fontSize: '24px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
                transition: 'all 0.2s ease',
                fontWeight: 'bold',
                lineHeight: '1'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>

            {/* Cal.com iframe */}
            <iframe
              src="https://cal.com/unsupervisedbias/45-min-meeting?embed=true&theme=dark"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Book a Call"
              style={{
                border: 'none',
                borderRadius: '16px'
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BookCall;
